import { APP_USER_ROLE } from '../Constants';
import { PUBLIC_CLIENT_APPLICATION, LOGIN_REQUEST, TOKEN_REQUEST } from './msalConfig'
import { GetMyRoles } from '../ApiHandler/UserRoleApi';

export const handleSignIn = async (callback) => {
    try {
        const loginResponse = await PUBLIC_CLIENT_APPLICATION.loginPopup(LOGIN_REQUEST);
        if (loginResponse.account) {
            PUBLIC_CLIENT_APPLICATION.setActiveAccount(loginResponse.account);
        }
        const tokenResponse = await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent(TOKEN_REQUEST);
        const credentials = await getUserCredentials(tokenResponse);
        if(!userHasAppAccess(credentials)){
            return callback("Missing Role");
        }

        callback(credentials);
    } catch (loginError) {
        console.error("Error during loginPopup:", loginError);
    }
}

export const silentLogin = async (callback) => {
    try{
        const tokenResponse = await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent(TOKEN_REQUEST);
        const credentials = await getUserCredentials(tokenResponse);
        if(!userHasAppAccess(credentials)){
            return callback("Missing Role");
        }

        callback(credentials);
    } catch (error) {
        callback(null)
    }
}

export const handleSignOut = async (callback) => {
    await PUBLIC_CLIENT_APPLICATION.logoutPopup();
    callback()
};

const userHasAppAccess = (credentials) => {
    return credentials.roles.includes(APP_USER_ROLE);
}

export function GetUserRoles(token) {
    const arrayToken = token.split('.');
    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    return tokenPayload.roles ?? [];
}

const getUserCredentials = async (tokenResponse) => {
    // Fetch merged roles (AD + DB) from the backend
    let roles;
    try {
        const result = await GetMyRoles(tokenResponse.accessToken);
        roles = result.roles ?? [];
    } catch {
        // Fall back to AD token roles if the backend call fails
        roles = GetUserRoles(tokenResponse.accessToken);
    }

    return {
        username: tokenResponse.idTokenClaims.preferred_username,
        name: tokenResponse.idTokenClaims.name,
        userGroups: tokenResponse.idTokenClaims.groups,
        roles,
        jwtToken: tokenResponse.accessToken
    }
}